import React, { useState } from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import "./pagination.css"
import { FaAngleLeft, FaAngleRight, FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";

const CustomPagination = ({ totalItems, limit, pageNo, handlePageClick }) => {
  const totalPages = Math.ceil(totalItems / limit);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Helper function to generate visible page numbers
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 3; // Number of visible page numbers
    const leftOffset = Math.max(0, pageNo - Math.floor(maxVisiblePages / 2));
    const rightOffset = Math.min(totalPages - 1, pageNo + Math.floor(maxVisiblePages / 2));

    if (leftOffset > 0) {
      pageNumbers.push(
        <button
          key={0}
          onClick={() => handlePageClick(0)}
          className={`pagination-btn ${pageNo === 0 ? 'active' : ''}`}
        >
          1
        </button>
      );

      if (leftOffset > 1) {
        pageNumbers.push(<span key="ellipsis-start" className="pagination-ellipsis">...</span>);
      }
    }

    for (let i = leftOffset; i <= rightOffset; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`pagination-btn ${pageNo === i ? 'active' : ''}`}
        >
          {i + 1}
        </button>
      );
    }

    if (rightOffset < totalPages - 1) {
      if (rightOffset < totalPages - 2) {
        pageNumbers.push(<span key="ellipsis-end" className="pagination-ellipsis">...</span>);
      }

      pageNumbers.push(
        <button
          key={totalPages - 1}
          onClick={() => handlePageClick(totalPages - 1)}
          className={`pagination-btn ${pageNo === totalPages - 1 ? 'active' : ''}`}
        >
          {totalPages}
        </button>
      );
    }

    return pageNumbers;
  };

  return (
    <div className="custom-pagination">
      <button
        onClick={() => handlePageClick(Math.max(pageNo - 1, 0))}
        disabled={pageNo === 0}
        className={`pagination-arrow ${pageNo === 0 ? 'disabled' : ''}`}
      >
        <FiArrowLeft />
      </button>

      {generatePageNumbers()}

      <button
        onClick={() => handlePageClick(Math.min(pageNo + 1, totalPages - 1))}
        disabled={pageNo === totalPages - 1}
        className={`pagination-arrow ${pageNo === totalPages - 1 ? 'disabled' : ''}`}
      >
        <FiArrowRight />
      </button>


      {/* <div className="flex items-center justify-between p-4 bg-white shadow-md rounded-md w-full max-w-md mx-auto">
        <div className="flex items-center space-x-2">
          <span className="text-gray-600 text-sm">Rows per page:</span>
          <select
            className="border border-gray-300 text-gray-700 rounded-md px-2 py-1 text-sm focus:outline-none"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(e.target.value)}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>

        <span className="text-sm text-gray-700">{pageNo} - {totalPages} of {totalPages}</span>

        <div className="flex items-center space-x-2">
          <button
            className="p-1 rounded-md text-gray-400 cursor-not-allowed"
            disabled
          >
            <FaAnglesLeft size={16} />
          </button>
          <button
            className="p-1 rounded-md text-gray-400 cursor-not-allowed"
            disabled
          >
            <FaAngleLeft size={16} />
          </button>
          <button
            className="p-1 rounded-md text-gray-400 cursor-not-allowed"
            disabled
          >
            <FaAngleRight size={16} />
          </button>
          <button
            className="p-1 rounded-md text-gray-400 cursor-not-allowed"
            disabled
          >
            <FaAnglesRight size={16} />
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default CustomPagination;
